module.exports = __webpack_public_path__ + "static/michelle@small-869e700fd403227ff5729bd2b319826d.jpg";